// @flow
export const filterId: 'building' = 'building';
